import {Injectable} from '@angular/core';
import { Router, UrlTree } from '@angular/router';

import {UserService} from '@core/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class LoginGuard  {
  constructor(
    private router: Router,
    private userService: UserService
  ) {
  }

  canActivate(): boolean | UrlTree {
    return !(this.userService.accessToken && this.userService.user) || this.router.parseUrl('');
  }
}
